import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import buildInfo from "@/version.json";

const shortDate = (iso) => {
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
    });
  } catch { return ""; }
};

export const VersionStamp = () => {
  const [backend, setBackend] = useState(null);
  useEffect(() => {
    api.get("/version").then((r) => setBackend(r.data)).catch(() => setBackend(false));
  }, []);

  const isPreview = window.location.host.includes("preview.emergentagent");
  const envLabel = isPreview ? "PREVIEW" : "LIVE";
  const mismatch = backend && backend.version !== buildInfo.version;

  const copy = () => {
    const text = `${envLabel} · app ${buildInfo.version} · api ${backend ? backend.version : "?"} · ${buildInfo.built_at}`;
    navigator.clipboard?.writeText(text).then(() => toast.success("Version copied")).catch(() => {});
  };

  return (
    <div
      className="px-2 py-1.5 text-[10px] leading-tight text-[#3F3F46] cursor-pointer select-none"
      onClick={copy}
      title="Tap to copy the full version info"
      data-testid="version-stamp"
    >
      <span className={`font-bold ${isPreview ? "text-[#B45309]" : "text-[#3F6212]"}`} data-testid="version-env">{envLabel}</span>
      <span> · {buildInfo.version} · {shortDate(buildInfo.built_at)}</span>
      {backend === false && <span className="block text-[#DC2626] font-semibold" data-testid="version-api-unreachable">API version unreachable</span>}
      {mismatch && (
        <span className="block text-[#B45309] font-semibold" data-testid="version-mismatch">
          API is {backend.version} — partial deploy?
        </span>
      )}
    </div>
  );
};
